module.exports = __webpack_public_path__ + "assets/images/pages/workshops/section-2-left.png?d83ac5a3";